import React from 'react';
import {
	Box,
	CircularProgress,
	LinearProgress,
	Typography,
} from '@mui/material';
import { Main, StyledCard, StyledCardInner } from '../styles/commonStyles';
import { Header } from './Header';

interface DepositingViewProps {
	balance: number;
	aptosBalance: number;
}

export const DepositingView: React.FC<DepositingViewProps> = ({ balance }) => {
	return (
		<Main>
			<Header />
			<StyledCard
				sx={{
					width: { xs: '90%', sm: '450px' },
					maxWidth: '450px',
					marginTop: { xs: '40px', sm: '70px', md: '120px' },
				}}
			>
				<StyledCardInner
					sx={{
						padding: { xs: '20px', sm: '24px', md: '28px' },
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<CircularProgress size={60} sx={{ mb: { xs: 2, sm: 3 } }} />
					<Typography
						variant="h5"
						gutterBottom
						fontFamily="Oxanium"
						sx={{
							fontSize: { xs: '20px', sm: '22px', md: '24px' },
							fontWeight: 500,
							mb: 2,
						}}
					>
						Processing Deposit
					</Typography>
					<Typography
						color="textSecondary"
						gutterBottom
						fontFamily="Oxanium"
						sx={{
							fontSize: { xs: '15px', sm: '16px' },
							fontWeight: 400,
							textAlign: 'center',
						}}
					>
						Deploying with Conservative strategy
					</Typography>

					<Box mt={3} width="100%">
						<Typography
							variant="body2"
							gutterBottom
							fontFamily="Oxanium"
							sx={{
								fontSize: {
									xs: '15px',
									sm: '16px',
									md: '18px',
								},
								mb: 2,
								textAlign: 'center',
							}}
						>
							Transferring funds... Complete
						</Typography>
						<LinearProgress
							variant="determinate"
							value={100}
							sx={{
								height: '10px',
								borderRadius: '10px',
								backgroundColor: 'lightgray',
							}}
						/>
					</Box>
				</StyledCardInner>
			</StyledCard>
		</Main>
	);
};
